import { SideItemOption, SideItemType } from '~/core/enums';

export const SIDE_ITEMS = [
  SideItemType.WALL_SIDE,
  SideItemType.APPLIANCE_SIDE,
  SideItemType.WATERFALL,
];

export const SIDE_ITEM_OPTIONS = [
  SideItemOption.BACKSPLASH,
  SideItemOption.WATERFALL,
];
